/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_TitleInputs */

const en_manual_qc_title = /** @type {(inputs: Manual_Qc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual QC`)
};

const fr_manual_qc_title = /** @type {(inputs: Manual_Qc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QC manuel`)
};

const de_manual_qc_title = /** @type {(inputs: Manual_Qc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuelle Qualitätskontrolle`)
};

const it_manual_qc_title = /** @type {(inputs: Manual_Qc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllo qualità manuale`)
};

const ru_manual_qc_title = /** @type {(inputs: Manual_Qc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ручной контроль качества`)
};

const es_manual_qc_title = /** @type {(inputs: Manual_Qc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control de calidad manual`)
};

const zh_cn2_manual_qc_title = /** @type {(inputs: Manual_Qc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人工质检`)
};

const ja_manual_qc_title = /** @type {(inputs: Manual_Qc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手動QC`)
};

const hi_manual_qc_title = /** @type {(inputs: Manual_Qc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैनुअल क्यूसी`)
};

const pt_pt2_manual_qc_title = /** @type {(inputs: Manual_Qc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controle de qualidade manual`)
};

/**
* | output |
* | --- |
* | "Manual QC" |
*
* @param {Manual_Qc_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_title = /** @type {((inputs?: Manual_Qc_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_title(inputs)
	if (locale === "de") return de_manual_qc_title(inputs)
	if (locale === "it") return it_manual_qc_title(inputs)
	if (locale === "ru") return ru_manual_qc_title(inputs)
	if (locale === "es") return es_manual_qc_title(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_title(inputs)
	if (locale === "ja") return ja_manual_qc_title(inputs)
	if (locale === "hi") return hi_manual_qc_title(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_title(inputs)
	return en_manual_qc_title(inputs)
});